import { apiGet, apiPost, apiPut, apiDelete } from './client'
import type { ApiResponse } from '@crm/shared'

export interface MashupRow {
  id: string
  tenant_id: string
  object_id: string
  title: string
  url: string
  sort_order: number
  created_at: string
}

export interface SettingsMashupRow extends MashupRow {
  object_label: string
  object_name: string
}

export async function fetchMashups(objectId: string) {
  return apiGet<ApiResponse<MashupRow[]>>(`/objects/${objectId}/mashups`)
}

export async function createMashup(objectId: string, data: { title: string; url: string; sort_order?: number }) {
  return apiPost<ApiResponse<MashupRow>, typeof data>(`/objects/${objectId}/mashups`, data)
}

export async function updateMashup(objectId: string, mashupId: string, data: { title?: string; url?: string; sort_order?: number }) {
  return apiPut<ApiResponse<MashupRow>, typeof data>(`/objects/${objectId}/mashups/${mashupId}`, data)
}

export async function deleteMashup(objectId: string, mashupId: string) {
  return apiDelete<ApiResponse<null>>(`/objects/${objectId}/mashups/${mashupId}`)
}

export async function fetchAllMashups(objectId?: string) {
  const path = objectId ? `/settings/mashups?object_id=${objectId}` : '/settings/mashups'
  return apiGet<ApiResponse<SettingsMashupRow[]>>(path)
}

export async function createSettingsMashup(data: { object_id: string; title: string; url: string; sort_order?: number }) {
  return apiPost<ApiResponse<SettingsMashupRow>, typeof data>('/settings/mashups', data)
}

export async function updateSettingsMashup(mashupId: string, data: { object_id?: string; title?: string; url?: string; sort_order?: number }) {
  return apiPut<ApiResponse<SettingsMashupRow>, typeof data>(`/settings/mashups/${mashupId}`, data)
}

export async function deleteSettingsMashup(mashupId: string) {
  return apiDelete<ApiResponse<null>>(`/settings/mashups/${mashupId}`)
}
